<mat-icon (click)="openMoveContactForm()" class="primary-light-color" style="cursor: pointer"
	>move_to_inbox</mat-icon
>
